import { render, staticRenderFns } from "./NewUserRecharge.vue?vue&type=template&id=4674c1dc&scoped=true&"
import script from "./NewUserRecharge.vue?vue&type=script&lang=js&"
export * from "./NewUserRecharge.vue?vue&type=script&lang=js&"
import style0 from "./NewUserRecharge.vue?vue&type=style&index=0&id=4674c1dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674c1dc",
  null
  
)

export default component.exports